import {
  IInputFieldProps,
  SelectFieldSchema,
  getFullPropertyPath,
  useGetDatasourceOptions
} from "@generation/core";
import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { RegisteredSelectField } from "../Components/RegisteredSelectField";
import { parseContentAfterFieldSelection } from "../Utils/Helpers/ParseContentAfterFieldSelection";
import { withFormFieldHoc } from "./hoc/withFormFieldHoc";

export const SelectField = React.memo(
  withFormFieldHoc((props: IInputFieldProps<SelectFieldSchema>) => {
    const { watch, setValue } = useFormContext();

    const { options, loadState } = useGetDatasourceOptions({
      field: props.field,
      name: props.name,
      getValue: watch,
      setValue: setValue
    });

    const currentValue = useWatch({ name: props.name });

    const labelFieldName = props.field.labelFieldName
      ? getFullPropertyPath(
          `${props.name.substring(0, props.name.lastIndexOf("."))}.`,
          props.field.labelFieldName
        )
      : `${props.name}Label`;

    React.useEffect(() => {
      if (currentValue && options) {
        const labelValue = options.find((item) => item.value === currentValue)?.label ?? undefined;

        setValue(
          labelFieldName,
          props.field.formatSelectedLabelValue
            ? props.field.formatSelectedLabelValue(labelValue ?? "")
            : labelValue
        );
      } else {
        setValue(labelFieldName, undefined);
      }
    }, [currentValue, options]);

    const contentAfterFieldSelection = parseContentAfterFieldSelection(
      props.field.optionToContentAfterText,
      currentValue
    );

    return (
      <>
        <RegisteredSelectField
          name={props.name}
          field={props.field}
          options={[
            ...(options ?? []).map((item) => ({
              label: item.label,
              value: item.value
            }))
          ]}
          loading={loadState}
          value={currentValue}
        />
        {contentAfterFieldSelection}
      </>
    );
  })
);
